module.exports = __webpack_public_path__ + "static/media/_astersk.851180c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_astersk.jpg
// module id = 52
// module chunks = 0